// components/MainContent.jsx
import React from "react";
import ContinuesTrainings from "./ContinuesTraining";
import ComingSoon from "./ComingSoon";
import LibraryCategories from "./LibraryCategories";
import Books from "./Books";
import Media from "./Media";
import News from "./News";
import Publications from "./Publications";
import Trainings from "./Trainings";

const MainContent = ({ activeSection, sections }) => {
  const currentSection = sections.find(
    (section) => section.id === activeSection
  );

  const renderContent = () => {
    if (!currentSection.available) {
      return <ComingSoon sectionName={currentSection.name} />;
    }

    switch (activeSection) {
      case "continues-trainings":
        return <ContinuesTrainings />;
      case "library-categories":
        return <LibraryCategories />;
      case "books":
        return <Books />;
      case "media":
        return <Media />;
      case "news":
        return <News />;
      case "publications":
        return <Publications />;
      case "trainings":
        return <Trainings />;
      default:
        return <ComingSoon sectionName={currentSection.name} />;
    }
  };

  return (
    <div className="flex-1 overflow-hidden">
      {/* Header */}
      <div className="bg-white shadow-lg border-b border-green-200">
        <div className="px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-800 mb-2">
                {currentSection.name}
              </h1>
              <div className="flex items-center space-x-4">
                <span className="text-green-600 font-semibold">
                  {currentSection.available ? "Active" : "Coming Soon"}
                </span>
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="relative">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center cursor-pointer hover:bg-green-200 transition-colors duration-200">
                  <span className="text-green-700 font-bold">U</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="h-[calc(100vh-120px)] overflow-y-auto p-8">
        {renderContent()}
      </div>
    </div>
  );
};

export default MainContent;
